<!--
 * @Date: 2022-03-16 14:13:51
 * @LastEditTime: 2022-03-23 18:07:04
 * @FilePath: \hc_website\src\views\homePage\technicalCapability\televisionHighPrecisionRendering\televisionHighPrecisionRendering.vue
-->
<template>
  <div class="cityZation" ref="cityZation">
    <video class="profile" controls ref="videoa" @play="playVideo">
      <source :src="videoResource" type="video/mp4" />
    </video>
    <div class="cityRight">
      <div class="visualization">
        <div class="contentleft">精</div>
        <div class="contentright">真实还原物理世界，高精度影片级实时渲染</div>
      </div>
      <div class="lint"></div>
      <div class="visualization">
        <div class="contentleft">艺</div>
        <div class="contentright">
          对景观、环境、交互采用艺术化手法，给用户带来不同感官体验
        </div>
      </div>
      <div class="lint"></div>
      <div class="visualization">
        <div class="contentleft">云</div>
        <div class="contentright">
          支持串流技术，充分利用云端渲染能力，使高精度模型在不同终端、不同场景下流畅浏览
        </div>
      </div>
      <div class="lint"></div>
      <div class="visualization">
        <div class="contentleft">集</div>
        <div class="contentright">
          与大数据平台、物联中台等业务数据进行集成，融合物联感知数据，实现高精度模型在IOC指挥控制中心等多终端的数据呈现
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ipconfig from "/public/ipconfig.js";
export default {
  data() {
    return {
      videoResource: ipconfig.ip + "/technicalCapability/home3.mp4",
      isCloseVideo: true,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    /**
     * @function handleScroll 滚动的事件 & 获取滚动的高度
     */
    handleScroll() {
      let scrollY = document.documentElement.scrollTop;
      let dom = this.$refs.cityZation;
      if (!dom) return;
      let elementTop = this.getElementTop(dom);
      if (
        scrollY > elementTop + dom.clientHeight ||
        scrollY < elementTop - dom.clientHeight
      ) {
        if (this.isCloseVideo) {
          this.$refs["videoa"].pause();
          this.isCloseVide = false;
        }
      }
    },
    /**
     * @function playVideo 播放video
     */
    playVideo() {
      this.isCloseVideo = true;
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
};
</script>
<style lang="scss" scoped>
.cityZation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .profile {
    width: 48%;
    height: 100%;
  }
  .cityRight {
    width: 48%;
    .visualization {
      display: flex;
      justify-content: flex-start;
      // align-items: center;

      .contentleft {
        font-size: 32px;
        color: #bc1e1d;
        margin-right: 20px;
      }
      .contentright {
        text-align: left;
        margin-top: 9px;
        font-size: 24px;
        color: #14171c;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
    .lint {
      width: 40px;
      height: 4px;
      background-color: #bc1e1d;
      margin: 25px 0;
    }
  }
}
</style>
